import { z } from 'zod';
import { IsoDateTimeSchema, QualityResultStatusSchema, UuidSchema } from './common.js';
export const QualityProcessingStatusSchema = z.enum([
    'pending',
    'processing',
    'completed',
    'failed',
    'not_applicable',
]);
export const ClaimQualityProcessingRequestSchema = z
    .object({
    sessionId: UuidSchema.optional(),
    limit: z.number().multipleOf(1).positive().max(100).prefault(20),
    leaseDurationMs: z.number().multipleOf(1).min(30_000).max(900_000).prefault(120_000),
})
    .strict();
export const QualityProcessingClaimSchema = z.object({
    sessionId: UuidSchema,
    projectId: UuidSchema,
    organizationId: UuidSchema,
    callId: z.string().nullable(),
    /** Null on rows that predate the field; the consumer treats that as VAPI. */
    conversationProvider: z.string().nullable().optional(),
    source: z.string(),
    status: z.string(),
    connectedAt: IsoDateTimeSchema.nullable(),
    endedAt: IsoDateTimeSchema.nullable(),
    processingStartedAt: IsoDateTimeSchema,
    attemptCount: z.number().multipleOf(1).nonnegative(),
    claimToken: UuidSchema,
});
export const ClaimQualityProcessingResponseSchema = z.object({
    items: z.array(QualityProcessingClaimSchema),
});
export const QualityProviderMessageSchema = z
    .object({
    role: z.string(),
    message: z.string().optional(),
    time: z.number().optional(),
})
    .strict();
export const QualityProviderDataSchema = z
    .object({
    id: z.string(),
    status: z.string(),
    endedReason: z.string().optional(),
    transcript: z.string().optional(),
    recordingUrl: z.string().optional(),
    cost: z.number().optional(),
    costBreakdown: z.record(z.string(), z.number()).optional(),
    startedAt: z.string().optional(),
    endedAt: z.string().optional(),
    durationSeconds: z.number().optional(),
    messages: z.array(QualityProviderMessageSchema).optional(),
    analysis: z.record(z.string(), z.unknown()).optional(),
    isProcessingComplete: z.boolean(),
})
    .strict();
const QualityTransitionBaseSchema = z.object({ claimToken: UuidSchema });
export const TransitionQualityProcessingRequestSchema = z.discriminatedUnion('action', [
    QualityTransitionBaseSchema.extend({
        action: z.literal('skip'),
        reason: z.literal('preview_not_applicable'),
        providerData: QualityProviderDataSchema,
    }),
    QualityTransitionBaseSchema.extend({
        action: z.literal('retry'),
        reason: z.string().min(1),
        nextAttemptAt: IsoDateTimeSchema,
        error: z.string().max(1000).optional(),
    }),
    QualityTransitionBaseSchema.extend({
        action: z.literal('fail'),
        reason: z.string().min(1),
        error: z.string().min(1).max(1000),
    }),
    QualityTransitionBaseSchema.extend({
        action: z.literal('complete'),
        qualityStatus: QualityResultStatusSchema,
        returnReasonCategory: z.enum(['technical_problems', 'did_not_finish']).optional(),
        providerData: QualityProviderDataSchema,
        consumableTransactionId: UuidSchema.optional(),
    }),
]);
export const QualityProcessingTransitionResponseSchema = z.object({
    sessionId: UuidSchema,
    status: QualityProcessingStatusSchema,
});
export const RequeueQualityProcessingResponseSchema = z.object({
    sessionId: UuidSchema,
    status: z.literal('pending'),
});
export const PendingQualityChargeSchema = z.object({
    sessionId: UuidSchema,
    organizationId: UuidSchema,
    conversationCost: z.number().nonnegative(),
});
export const PendingQualityChargesResponseSchema = z.object({
    items: z.array(PendingQualityChargeSchema),
});
export const MarkQualityChargeRequestSchema = z.object({
    consumableTransactionId: UuidSchema,
});
//# sourceMappingURL=QualityProcessing.js.map